/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking on a roast or slow-cooked dish at a 45-minute interval.`)
};

const es_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar un asado o un plato cocinado a fuego lento a intervalos de 45 minutos.`)
};

const de_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bratenstück oder Schmorgericht im 45-Minuten-Intervall kontrollieren.`)
};

const nl_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een braadstuk of langzaam gegaard gerecht controleren met een interval van 45 minuten.`)
};

const fr_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier un rôti ou un plat en cuisson lente à intervalles de 45 minutes.`)
};

const it_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllare un arrosto o un piatto a cottura lenta a intervalli di 45 minuti.`)
};

const pt_br2_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checar um assado ou prato cozido em fogo baixo em intervalos de 45 minutos.`)
};

const pt_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar um assado ou um prato de cozedura lenta a intervalos de 45 minutos.`)
};

const ja_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローストや低温調理の料理を45分間隔で確認する。`)
};

const zh_timer_u45m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每隔45分钟查看一次烘烤或慢炖菜肴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_use3", locale)
	if (locale === "en") return en_timer_u45m_use3(inputs)
	if (locale === "es") return es_timer_u45m_use3(inputs)
	if (locale === "de") return de_timer_u45m_use3(inputs)
	if (locale === "nl") return nl_timer_u45m_use3(inputs)
	if (locale === "fr") return fr_timer_u45m_use3(inputs)
	if (locale === "it") return it_timer_u45m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_use3(inputs)
	if (locale === "pt") return pt_timer_u45m_use3(inputs)
	if (locale === "ja") return ja_timer_u45m_use3(inputs)
	return zh_timer_u45m_use3(inputs)
};